// --- START OF FILE RedefinirEmailStyle.js ---

import styled from "styled-components";

export const ContainerRedefinirSenha = styled.div`
    width: 100%;
    min-height: 100vh;
    padding: 40px;
    box-sizing: border-box;
    background-image: url('/textura.jpg');
    background-size: cover;
    background-attachment: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
`;

export const ImageBackground = styled.img`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 0;
    width: auto;
    height: 60%;
    opacity: 0.05;
`;

export const ContentBox = styled.div`
    background: rgba(30, 30, 30, 0.9);
    backdrop-filter: blur(10px);
    border-radius: 8px;
    padding: 30px 40px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37);
    max-width: 900px;
    width: 100%;
    margin: 0 auto;
    z-index: 1;
`;

export const Header = styled.div`
    text-align: center;
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    
    h2 {
        margin: 0;
        color: #E6AA3A;
        font-size: 28px;
    }
`;

export const Step = styled.div`
    margin-bottom: 30px;
    
    p {
        margin: 0 0 15px 0;
        color: #fff;
        font-size: 18px;
        font-weight: 600;
        opacity: 0.9;
    }
`;

export const SearchBox = styled.div`
    .inputBoxSearch {
        display: flex;
        margin-bottom: 15px;
    }

    input {
        flex-grow: 1;
        height: 45px;
        border: 1px solid rgba(255, 255, 255, 0.2);
        background: rgba(0,0,0,0.3);
        padding: 0 20px;
        color: #fff;
        border-radius: 6px 0 0 6px;
        font-size: 16px;
        &:focus { outline: none; border-color: #E6AA3A; }
    }
    
    button {
        width: 60px;
        height: 45px;
        border: none;
        background: #E6AA3A;
        color: #111;
        cursor: pointer;
        border-radius: 0 6px 6px 0;
        font-size: 18px;
        transition: background-color 0.2s;
        &:hover:not(:disabled) { background-color: #f7b74a; }
        &:disabled { opacity: 0.5; cursor: not-allowed; }
    }
`;

export const SearchedClients = styled.div`
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 6px;
    overflow: hidden;

    .columns, .row, .rowSelected {
        display: grid;
        grid-template-columns: 3fr 2fr 3fr;
        padding: 12px 15px;
        color: #fff;
        align-items: center;
        gap: 15px;
    }
    .columns {
        font-weight: bold;
        background: rgba(0,0,0,0.2);
        border-bottom: 2px solid #E6AA3A;
        font-size: 12px;
        text-transform: uppercase;
    }
    .tabelona {
        max-height: 250px;
        overflow-y: auto;
    }
    .row {
        cursor: pointer;
        border-bottom: 1px solid rgba(255,255,255,0.1);
        transition: background-color 0.2s;
        &:hover { background: rgba(230, 170, 58, 0.1); }
    }
    .rowSelected {
        background: #E6AA3A;
        color: #111;
        font-weight: bold;
        grid-template-columns: 3fr 2fr 3fr auto;

        button {
            background: transparent;
            border: none;
            color: #111;
            cursor: pointer;
            font-size: 16px;
        }
    }
`;

export const SelectedContainer = styled.div`
    padding-top: 20px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    flex-direction: column;
    gap: 20px;
    max-width: 500px;
    margin: 0 auto;
`;

export const BoxInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;

    label {
        margin: 0;
        font-size: 12px;
        color: #ccc;
        font-weight: 500;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }
    
    input {
        height: 45px;
        border: 1px solid rgba(255, 255, 255, 0.2);
        background: rgba(0,0,0,0.3);
        padding: 0 15px;
        color: #fff;
        border-radius: 6px;
        font-size: 16px;
        &:focus { outline: none; border-color: #E6AA3A; }
        &:read-only { background: rgba(0,0,0,0.2); color: #888; cursor: not-allowed; }
    }
`;

export const RedefineButton = styled.button`
    background: #c0392b;
    color: #fff;
    border: none;
    border-radius: 6px;
    padding: 15px 30px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    margin-top: 10px;

    &:hover:not(:disabled) { 
        background: #e74c3c;
        transform: translateY(-2px);
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;